import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Input, Label } from 'reactstrap';
import { useIntl } from 'react-intl';

const AccessModalAccessEdition = ({
  files,
  mode,
  handleChangeSearchable,
}) => {
  const intl = useIntl();

  if (mode !== 'files') return null;

  return (
    <div className="access-type">
      <div className={classnames('access-type-form', 'access-type-form-editions')}>
        <div className="access-type-icon">
          <div className="user-avatar share-avatar">
            <div className="avatar avatar-40 icon-avatar outline-avatar primary">
              <i className="fas fa-eye-low-vision" />
            </div>
          </div>
        </div>
        <div className="access-type-select access-type-select-switch-edition-visible">
          <Label for="switch-edition-visible" className="switch">
            <div className="switch-details">
              <h5 className="access-type-title">
                {intl.formatMessage({ defaultMessage: 'Show in workspace' })}
              </h5>
              <p className="access-type-details">
                {intl.formatMessage({
                  defaultMessage: `Make this edition visible as a new file in your workspace. 
                    It will also remain as an edition.`,
                })}
              </p>
            </div>
            <div className="switch-control input-inner">
              <Input
                type="checkbox"
                name="switchEditionVisible"
                id="switch-edition-visible"
                value={files[0].searchable}
                defaultChecked={files[0].searchable}
                onChange={handleChangeSearchable}
              />
              <i />
            </div>
          </Label>
        </div>
      </div>
    </div>
  );
};

AccessModalAccessEdition.propTypes = {
  files: PropTypes.array.isRequired,
  mode: PropTypes.string.isRequired,
  handleChangeSearchable: PropTypes.func.isRequired,
};

export default AccessModalAccessEdition;
